module.exports = __webpack_public_path__ + "static/ac-755db2cad1b9a74e58747ef5f10b6100.png";